import { parse } from "qs";
import {
  IS_AIMODE_LOCAL_STORAGE_KEY,
  IS_DEMO_LOCAL_STORAGE_KEY,
} from "@/configs/site";

export const isDevEnv = Boolean(
  window.location.hostname === "dev.trustlogix.io" ||
    window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

//@ts-expect-error Cypress is a global variable set by Cypress test runner
export const isTestEnv = Boolean(window.parent?.Cypress);

const existingDemoValue =
  localStorage.getItem(IS_DEMO_LOCAL_STORAGE_KEY) || "false";
const existingAIModeValue =
  localStorage.getItem(IS_AIMODE_LOCAL_STORAGE_KEY) || "false";

export const CONFIGKEY = "__OVERRIDES_CONFIGURATION__";
export const initConfig = () => {
  if (!isDevEnv) return;
  const params: URLSearchParams = new URLSearchParams(window.location.search);
  const config = params.get("overrides");
  // Absent param: keep existing sessionStorage (do not wipe on reload).
  // Present param (including "{}") still writes — explicit clear stays supported.
  if (config === null) return;
  try {
    const parseConfig = JSON.parse(config);
    sessionStorage.setItem(
      CONFIGKEY,
      JSON.stringify(parseConfig.configParameters || {}),
    );
  } catch {
    // eslint-disable-next-line no-console
    console.error("invalided overrides config", config);
  }
};

export const getOverridesConfig = (): Record<string, boolean | string> => {
  if (!isDevEnv && !isTestEnv) return {};
  const config = JSON.parse(sessionStorage.getItem(CONFIGKEY) || "{}");
  const parsedConfig: Record<string, boolean | string> = {};

  for (const [k, v] of Object.entries(config)) {
    if (v === "true") {
      parsedConfig[k] = true;
    } else if (v === "false") {
      parsedConfig[k] = false;
    } else {
      parsedConfig[k] = v as string;
    }
  }

  return parsedConfig;
};

const coerceFlagValue = (value: unknown, fallback: string) => {
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value) && typeof value[0] === "string") {
    return value[0];
  }
  return fallback;
};

export const setEnvs = () => {
  const parsedParams = parse(window.location.search.replace("?", ""));

  const isDemo = coerceFlagValue(parsedParams?.isDemo, existingDemoValue);
  const isAIMode = coerceFlagValue(parsedParams?.isAIMode, existingAIModeValue);

  localStorage.setItem(IS_DEMO_LOCAL_STORAGE_KEY, isDemo);
  localStorage.setItem(IS_AIMODE_LOCAL_STORAGE_KEY, isAIMode);
};
